export class UserSession {
  personalInfo = null; 
  employers = [];
  incomes = [];
  fundingInformation = null;
  constructor(args = null) {
    if (args) {
      this.personalInfo = args.personalInfo; 
      this.employers = args.employers || [];
      this.incomes = args.incomes || [];
      this.fundingInformation = args.fundingInformation
    }
  }
  setPersonalInfo(personalInfo) {
    this.personalInfo = personalInfo;
  } 
  addEmployer(employer) {
    this.employers.push(employer);
  }
  updateEmployer(employer) {
    this.employers = this.employers.map((emp) => {
      if (emp.id === employer.id) {
        return {...emp,...employer};
      } else {
        return emp;
      }
    });
  }
  removeEmployer(id) {
    this.employers = this.employers.filter((s) => s.id !== id);
  }

  addIncome(income) {
    this.incomes.push(income);
  }
  updateIncome(income) {
    this.incomes = this.incomes.map((inc) => {
      if (inc.id === income.id) {
        return {...inc,...income};
      } else {
        return inc;
      }
    });
  }
  removeIncome(id) {
    this.incomes = this.incomes.filter((s) => s.id !== id);
  }
  isEmpty(){
    return (!this.personalInfo || Object.keys(this.personalInfo).length === 0) 
    && (!this.employers || this.employers.length === 0)
    && (!this.incomes || this.incomes.length === 0)
  }
  setFundingInformation(fundingInformation){
    this.fundingInformation = fundingInformation;
  }
}

const SESSION_DATA_KEY_NAME = "USER_SESSION";

export const SessionService = {
  getPersonalInfo,
  setPersonalInfo,
  clearSession,
  getFinancialInfo,
  setFinancialInfo,
  getSession,
  setSession,
  addEmployer,
  updateEmployer,
  removeEmployer,
  addIncome,
  updateIncome,
  removeIncome,
  isEmptySession,
  setFundingInformation,
  getFundingInformation,
};

function getPersonalInfo() {
  const currentSession = getSession();
  if (currentSession) {
    return currentSession.personalInfo;
  } else return null;
}
function setPersonalInfo(personalInfo) {
  const currentSession = getSession();
  currentSession.setPersonalInfo(personalInfo);
  setSession(currentSession);
}

function getFinancialInfo() {
  const currentSession = getSession();
  if (currentSession) {
    return currentSession.financialInfo;
  } else return null;
}
function setFinancialInfo(financialInfo) {
  const currentSession = getSession();
  currentSession.setFinancialInfo(financialInfo);
  setSession(currentSession);
}

function addEmployer(employer) {
  const currentSession = getSession();
  currentSession.addEmployer(employer);
  setSession(currentSession);
}
function updateEmployer(employer) {
  const currentSession = getSession();
  currentSession.updateEmployer(employer);
  setSession(currentSession);
}
function removeEmployer(id) {
  const currentSession = getSession();
  currentSession.removeEmployer(id);
  setSession(currentSession);
}

function addIncome(income) {
  const currentSession = getSession();
  currentSession.addIncome(income);
  setSession(currentSession);
}
function updateIncome(income) {
  const currentSession = getSession();
  currentSession.updateIncome(income);
  setSession(currentSession);
}
function removeIncome(id) {
  const currentSession = getSession();
  currentSession.removeIncome(id);
  setSession(currentSession);
}

function isEmptySession() {
  return getSession().isEmpty();
}
function getFundingInformation() {
  const currentSession = getSession();
  if (currentSession) {
    return currentSession.fundingInformation;
  } else return null;
}
function setFundingInformation(fundingInformation) {
  const currentSession = getSession();
  currentSession.setFundingInformation(fundingInformation);
  setSession(currentSession);
}
/**
 * 
 * @param {UserSession} userSession 
 */
function setSession(userSession) {
  sessionStorage.setItem(SESSION_DATA_KEY_NAME, JSON.stringify(userSession));
}
/**
 * 
 * @returns userSession
 */
function getSession() {
  return new UserSession(JSON.parse(sessionStorage.getItem(SESSION_DATA_KEY_NAME)));
}
function clearSession(){ 
    sessionStorage.removeItem(SESSION_DATA_KEY_NAME)
}


